import {Component, ViewEncapsulation} from '@angular/core';
import { Observable } from 'rxjs';
import { UigWishListService } from '../../uig-wish-list.service';
import {WishListComponent} from '@spartacus/cart/wish-list/components';
import {Cart, OrderEntry} from '@spartacus/cart/base/root';
import {WishListService} from '@spartacus/cart/wish-list/core';

@Component({
    selector: 'app-uig-wish-list',
    templateUrl: './uig-wish-list.component.html',
    styleUrls: ['./uig-wish-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigWishListComponent extends WishListComponent {
  wishList$: Observable<Cart> = this.uigWishListService.getWishList();
  loading$: Observable<boolean> = this.uigWishListService.getWishListLoading();

  constructor(
    protected wishListService: WishListService,
    protected uigWishListService: UigWishListService
  ) {
    super(wishListService);
  }

  removeEntry(item: OrderEntry) {
    this.uigWishListService.removeEntry(item);
  }
}
